<template>
    <!-- 竞赛管理 参赛选手 -->
    <div class="board">
        <div v-hasPermi="['arrangement:examinee:list']">
            <div class="title">
                <span class="name">{{ examineeTextConfig.title }}</span>
            </div>
            <el-form :inline="true" :model="form" ref="form">
                <el-form-item>
                    <el-button type="primary" @click="openAddDialog" :disabled="examStatus ==3"
                               v-hasPermi="['arrangement:examinee:save']">{{ examineeTextConfig.button.add }}
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="importDialogVisible = true" :disabled="examStatus ==3"
                               v-hasPermi="['arrangement:examinee:import']">{{ examineeTextConfig.button.batchAdd }}
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="danger" @click="batchDelete()" :disabled="examStatus >=2"
                               v-hasPermi="['arrangement:examinee:delete']">{{ examineeTextConfig.button.delete }}
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.examineeName" clearable
                              :placeholder="examineeTextConfig.form.examineeNameTip"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.admissionNo" clearable
                              :placeholder="examineeTextConfig.form.admissionNoTip"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search(1)">{{ examineeTextConfig.form.search }}</el-button>
                    <el-button @click="reset()">{{ examineeTextConfig.form.reset }}</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
                      element-loading-spinner="el-icon-loading" ref="multipleTable" stripe size="medium"
                      @selection-change="handleSelectionChange" height="500px">
                <el-table-column type="selection" min-width="48" align="center"></el-table-column>
                <el-table-column prop="examineeName" :label="tableTextConfig.examineeName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="admissionNo" :label="tableTextConfig.admissionNo" min-width="100">
                </el-table-column>
                <el-table-column
                        :label="tableTextConfig.examineeIdcard"
                        min-width="150px"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!-- 显示样式：部分掩码123456********123X -->
                        <span>{{ maskIdCard(scope.row.examineeIdcard) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="pilotSchool" :label="tableTextConfig.pilotSchool" min-width="100">
                </el-table-column>
                <el-table-column prop="assessmentSite" :label="tableTextConfig.assessmentSite" min-width="100">
                </el-table-column>
                <el-table-column prop="centreName" :label="tableTextConfig.centreName" min-width="100">
                </el-table-column>
                <el-table-column prop="seatNo" :label="tableTextConfig.seatNo" min-width="50">
                </el-table-column>
                <el-table-column :label="tableTextConfig.update" min-width="100px">
                    <template slot-scope="scope">
                        <p>{{ scope.row.updatedByUsername }}</p>
                        <p class="updateDate">{{ scope.row.updatedAt | formatTime }}</p>
                    </template>
                </el-table-column>

                <el-table-column label="编辑" width="70px">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="openUpdateDialog(scope.row)" :disabled="examStatus >=2">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>

                <el-table-column :label="tableTextConfig.operate" width="70px">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="delet(scope.row)" :disabled="examStatus >=2">
                            {{ tableTextConfig.button.delete.name }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize"
                        :total.sync="total"></pagination>
            <add-examinee-dialog ref="addDialog" :examId="examId" @success="search(1)"></add-examinee-dialog>
            <update-examinee-dialog ref="updateDialog" :examId="examId" @success="search(1)"></update-examinee-dialog>
            <import-dialog :show.sync="importDialogVisible" :examId="examId" @close="close"></import-dialog>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination/pagination.vue'
import {judgePermissions} from '@/utils/common.js'
import addExamineeDialog from '../../dialog/addExamineeDialog.vue'
import updateExamineeDialog from '../../dialog/updateExamineeDialog.vue'
import importDialog from '../../dialog/importExam.vue'

/**
 * 参赛选手
 */
export default {
    components: {
        addExamineeDialog, pagination, importDialog, updateExamineeDialog,//uploadFaceDialog
    },
    props: ['examId', 'examStatus'],
    data() {
        return {
            height: 250,
            loading: false,
            form: {
                examId: this.examId,
                examineeName: '',
                admissionNo: '',
                status: null,
                pageNumber: 1,
                pageSize: 20
            },
            total: 0,
            tableData: [],
            row: null,
            selectRow: [],
            importDialogVisible: false,
            // uploadFaceDialogVisible: false,
        }
    },
    computed: {
        examineeTextConfig() {
            return this.$store.state.global.textConfig.backend.arrangement.examEdit.examinee
        },
        tableTextConfig() {
            return this.examineeTextConfig.table
        },
        buttonTextConfig() {
            return this.tableTextConfig.button
        },
    },
    methods: {
        judgePermissions,
        search(val) {
            this.loading = true
            if (val) {
                this.form.pageNumber = val
            }
            this.form.examId = this.examId
            this.$store.dispatch("getArrangeExamList", this.form).then(res => {
                if (res) {
                    this.loading = false
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                }
            });
            this.$nextTick(() => {
                this.$refs.multipleTable.doLayout()
            })
        },
        reset() {
            this.form.examineeName = ''
            this.form.admissionNo = ''
            this.search(1)

        },
        handleSelectionChange(val) {
            this.selectRow = []
            for (let i = 0; i < val.length; i++) {
                const e = val[i];
                this.selectRow.push(e)
            }
        },
        openAddDialog() {
            this.$refs.addDialog.open()
        },
        openUpdateDialog(row) {
            console.log(row)
            this.$refs.updateDialog.open(row)
        },
        close() {
            this.importDialogVisible = false;
            // this.uploadFaceDialogVisible = false;
            this.search(1)
        },
        updateHeight() {
            this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 150
            this.height = this.height < 460 ? 460 : this.height
        },
        choose(tableData) {
            this.tableData = []
            for (let i = 0; i < tableData.length; i++) {
                this.tableData.push(tableData[i])
            }
        },
        delet(row) {
            let deleteTextConfig = this.tableTextConfig.button.delete
            let deleteMsg = deleteTextConfig.message.signMix(row.examineeName + "(" + row.admissionNo + ")")
            this.$confirm(deleteMsg, deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteArrangeExam", {examId: this.examId, ids: row.id + ''}).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: deleteTextConfig.success
                        });
                        this.search(1)
                    }
                });
            }).catch(() => {
            });
        },
        batchDelete() {
            let row = []
            let deleteUser = "";
            if (this.selectRow.length == 0) {
                this.$message({
                    type: 'warning',
                    message: "请选择要删除的选手"
                });
                return
            }
            for (let j = 0; j < this.selectRow.length; j++) {
                const e = this.selectRow[j].id;
                row.push(e)
                deleteUser += this.selectRow[j].examineeName + "(" + this.selectRow[j].admissionNo + ")" + "、";
            }
            let deleteTextConfig = this.tableTextConfig.button.delete
            this.$confirm(deleteTextConfig.message.signMix(deleteUser.substring(0, deleteUser.length - 1)), deleteTextConfig.title, {
                confirmButtonText: deleteTextConfig.ok,
                cancelButtonText: deleteTextConfig.cancel,
                type: 'warning'
            }).then(() => {
                this.$store.dispatch("deleteArrangeExam", {examId: this.examId, ids: row.join(',')}).then(res => {
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: deleteTextConfig.success
                        });
                        this.search(1)
                    }
                })
            }).catch(() => {
            });
        },
        maskIdCard(idCard) {
            if (!idCard || idCard.length < 9) {
                return idCard
            }
            return idCard.substring(0, 6) + '********' + idCard.substring(idCard.length - 3)
        },
    },
    mounted() {
        const that = this;
        setTimeout(() => {
            that.updateHeight()
        }, 200);
        window.onresize = () => {
            that.updateHeight()
        };
    },
    created() {
        if (this.examId) {
            this.$store.dispatch("getArrangeExamList", this.form).then(res => {
                if (res) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                }
            });
        }
    },
}
</script>

<style scoped>
.face-img-small {
    height: 50px;
    width: auto;
    cursor: pointer;
    border-radius: 4px;
    display: inline-block;
}
</style>
<style>
/* append-to-body 的浮层不在当前组件根下，需非 scoped */
.exadminee-face-img-popover.el-popover {
    width: auto !important;
    min-width: 0;
    padding: 4px;
    box-sizing: border-box;
}

.exadminee-face-img-large {
    height: 160px;
    width: auto;
    display: block;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    border: 2px solid #fff;
}
</style>

